import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-even.svg";
import * as styles from "./Icon.module.scss";

type IconEvenProps = React.SVGProps<SVGSVGElement>;

export const IconEven = ({ className, ...props }: IconEvenProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
